import React from 'react';
import moment from 'moment';

import './_style.scss';

class DateClock extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        time: this.formatDate()
      };
    }

    formatDate() {
        return moment().locale('pt-br').format('dddd[,] D [de] MMMM [de] YYYY [-] h:mm A');
    }

    componentDidMount() {
      this.intervalID = setInterval(
        () => this.tick(),
        1000
      );
    }

    componentWillUnmount() {
      clearInterval(this.intervalID);
    }

    tick() {
      this.setState({
        time: this.formatDate()
      });
    }

    render() {

      let _className = 'date_clock';

      if (this.props.className)
        _className = ` ${this.props.className}`;


      return (
        <div className={_className}>
          { this.state.time }
        </div>
      );
    }
  }

  export default DateClock